import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/video-off.vue
var o = {
	name: "DtIconVideoOff",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--video-off"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Video Off",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M.646.646a.5.5 0 0 1 .708 0l10 10a.5.5 0 0 1-.708.708l-1.949-1.95a1.5 1.5 0 0 1-1.198.598H2a1.5 1.5 0 0 1-1.5-1.5V3.498a1.5 1.5 0 0 1 .911-1.38l-.765-.764a.5.5 0 0 1 0-.708Zm1.645 2.352H2a.5.5 0 0 0-.5.5v5.004a.5.5 0 0 0 .5.5h5.499a.5.5 0 0 0 .468-.325L2.291 2.998Zm5.208 0h-1.67a.5.5 0 0 1 0-1h1.67a1.5 1.5 0 0 1 1.5 1.5v.758l1.817-.72A.5.5 0 0 1 11.5 4v4a.5.5 0 0 1-1 0V4.736l-1.816.72A.5.5 0 0 1 8 4.993l-.001-.5v-.995a.5.5 0 0 0-.5-.5Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=video-off.js.map